import IconButton from '@mui/material/IconButton';
import { withStyles } from '@mui/styles';
import Icon from 'Components/Icon';
import React from 'react';
import styles from './styles';

const Component = props => {
    const
        { count, page, rowsPerPage, onPageChange, classes } = props,
        handleBackButtonClick = () => onPageChange(null, page - 1),
        handleFirstPageButtonClick = () => onPageChange(null, 0),
        handleLastPageButtonClick = () => onPageChange(null, Math.max(0, Math.ceil(count / rowsPerPage) - 1)),
        handleNextButtonClick = () => onPageChange(null, page + 1);

    return (
        <div className={classes.root}>
            <IconButton disabled={page === 0} onClick={handleFirstPageButtonClick}>
                <Icon icon={['fas', 'arrow-to-left']} size="xs"/>
            </IconButton>
            <IconButton disabled={page === 0} onClick={handleBackButtonClick}>
                <Icon icon={['fas', 'chevron-left']} size="xs"/>
            </IconButton>
            <IconButton disabled={page >= Math.ceil(count / rowsPerPage) - 1} onClick={handleNextButtonClick}>
                <Icon icon={['fas', 'chevron-right']} size="xs"/>
            </IconButton>
            <IconButton disabled={page >= Math.ceil(count / rowsPerPage) - 1} onClick={handleLastPageButtonClick}>
                <Icon icon={['fas', 'arrow-to-right']} size="xs"/>
            </IconButton>
        </div>
    );
};

export default withStyles(styles)(Component);
